<template>
  <aside class="sidebar">
    <nav class="side-nav">
      <a
        v-for="item in menuItems"
        :key="item.key"
        href="#"
        class="side-item"
        :class="{ active: activeSide === item.key }"
        @click.prevent="$emit('nav', item.key)"
      >
        <span class="side-item__icon" aria-hidden="true">{{ item.icon }}</span>
        <b class="side-item__label">
          <span class="side-item__label-text">{{ item.label }}</span>
          <span
            v-if="menuBadgeCount(item.key) > 0"
            class="side-item__badge"
            :aria-label="$t('slip.unreadAria', { count: menuBadgeCount(item.key) })"
          >{{ menuBadgeLabel(item.key) }}</span>
        </b>
      </a>
    </nav>

    <BlackGoldJackpotBox />

    <div class="sidebar-banners">
      <button
        type="button"
        class="sidebar-banner sidebar-banner--telegram"
        @click="onTelegramClick"
      >
        <img :src="telegramBannerUrl" :alt="$t('nav.telegramInquiry')" loading="lazy" decoding="async">
      </button>
      <a
        href="#"
        class="sidebar-banner sidebar-banner--brand"
        @click.prevent="$emit('home')"
      >
        <img :src="brandBannerUrl" :alt="$t('brand.name')" loading="lazy" decoding="async">
      </a>
    </div>
  </aside>
</template>

<script>
import { BLACK_GOLD_DATA } from '@/data/blackGoldSite'
import BlackGoldJackpotBox from '@/components/black-gold/BlackGoldJackpotBox.vue'
import { getTelegramInquiryBannerUrl, resolveSiteBannerUrl } from '@/utils/siteBrand'

export default {
  name: 'BlackGoldSidebar',
  components: { BlackGoldJackpotBox },
  props: {
    activeSide: { type: String, default: 'home' },
    telegramId: { type: String, default: '' },
    sideMenu: {
      type: Array,
      default: null
    },
    menuBadges: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    telegramBannerUrl () {
      return getTelegramInquiryBannerUrl(this.$i18n.locale)
    },
    brandBannerUrl () {
      return resolveSiteBannerUrl(this.$store.state.siteInfo)
    },
    menuItems () {
      if (Array.isArray(this.sideMenu) && this.sideMenu.length) {
        return this.sideMenu
      }
      return BLACK_GOLD_DATA.sideMenu
    }
  },
  methods: {
    onTelegramClick () {
      this.$emit('telegram')
    },
    menuBadgeCount (key) {
      const value = Number(this.menuBadges && this.menuBadges[key])
      if (!Number.isFinite(value) || value <= 0) return 0
      return Math.floor(value)
    },
    menuBadgeLabel (key) {
      const count = this.menuBadgeCount(key)
      if (count <= 0) return ''
      return count > 99 ? '99+' : String(count)
    }
  }
}
</script>
